import location from '@/lib/utils/location';
import { track, intercom } from '@/lib/analytics';

export function requestInfo(intercom, track, location) {
  return async function execute(email) {
    const source = location();
    await intercom('update', { email });
    await track('requested-information', { email, source });
  };
}

export default requestInfo(intercom, track, location);
